import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core';
import { DragSource } from 'react-dnd';
import { compose } from '../../../utility';
import SignatureIcon from '../../../assets/signature.svg';
import c from '../../constants';
import styles from './signature.styles';
import { signaturePreview } from './dragPreview';

const signatureSource = {
  beginDrag(props) {
    const { id } = props;
    return { id };
  },
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    connectDragPreview: connect.dragPreview(),
  };
}

type PropType = {
  connectDragPreview: Function,
  connectDragSource: Function,
  handleClick: Function,
  handleKeyDown: Function,
  classes: Object
}

class SignatureC extends React.PureComponent<PropType, *> {

  componentDidMount() {
    const preview = new Image();
    preview.src = signaturePreview;
    preview.onload = () => this.props.connectDragPreview && this.props.connectDragPreview(preview, { offsetX: 0, offsetY: 0 });
  }

  render() {
    const {
      connectDragSource, handleClick, classes, handleKeyDown,
    } = this.props;
    return ((
      connectDragSource && connectDragSource((
        <div
          role="button"
          tabIndex="0"
          onKeyDown={ev => handleKeyDown(ev, c.ItemTypes.SIGNATURE)}
          onClick={ev => handleClick(ev, c.ItemTypes.SIGNATURE)}
          className={classNames(classes.root, 'fieldOutClick')}
          data-testid="signatureTool"
        >
          <SignatureIcon className={classes.signatureFieldIcon} />
          <span className={classes.legend}>Signature</span>
        </div>
      ))
    ));
  }

}

export const Signature = compose(
  DragSource(c.ItemTypes.SIGNATURE, signatureSource, collect),
  withStyles(styles, { withTheme: true }),
)(SignatureC);
